var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "IC-Combined",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 954,
    height: 390,
    viewBox: "0 0 954 568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .left-circle {fill: var(--field-left-circle-color);}\n      .center-left {fill: var(--field-center-left-color);}\n      .center-right {fill: var(--field-center-right-color);}\n      .right-circle {fill: var(--field-right-circle-color);}\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9499",
    width: 954,
    height: 568,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18785",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10422",
    d: "M474,567.937h6.481M954,0H0V568H954ZM6,6H73.171C183.748,45.961,258,157.608,258,284c0,126.327-74.178,237.922-184.661,277.937H73V562H6ZM89.987,561.937c48.372-20.71,90.023-55.507,121.129-101.392,34.912-51.493,53.365-112.563,53.365-176.608s-18.453-125.115-53.365-176.608C180.01,61.444,138.359,26.647,89.987,5.937H474v556Zm390.494-556H864.494c-48.372,20.71-90.023,55.507-121.129,101.392C708.453,158.822,690,219.892,690,283.937V284c0,64.045,18.454,125.115,53.365,176.608,31.077,45.836,72.671,80.612,120.978,101.329H480.481ZM948,562H881.481v-.063h-.651C770.262,521.978,696.013,410.347,696,283.969,696.013,157.589,770.261,45.958,880.829,6H948Z",
    fill: "#333a40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9497",
    width: 6,
    height: 90,
    transform: "translate(0 239.264)",
    fill: "#cf001b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9498",
    width: 6,
    height: 90,
    transform: "translate(947.88 239.264)",
    fill: "#cf001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10423",
    d: "M743.365,460.64C708.454,409.147,690,348.077,690,284.032v-.063c0-64.045,18.453-125.115,53.365-176.608C774.471,61.476,816.122,26.679,864.494,5.969H480.481v556H864.343c-48.307-20.717-89.9-55.493-120.978-101.329",
    className: "center-right"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10424",
    d: "M211.116,107.361c34.912,51.493,53.365,112.563,53.365,176.608s-18.453,125.114-53.365,176.608c-31.106,45.885-72.757,80.682-121.129,101.392H474v-556H89.987c48.372,20.71,90.023,55.507,121.129,101.392",
    className: "center-left"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10425",
    d: "M73,562.031v-.062h.339C183.822,521.954,258,410.359,258,284.032c0-126.392-74.252-238.039-184.829-278H6v556Z",
    className: "left-circle"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10426",
    d: "M696,284c.012,126.378,74.262,238.01,184.83,277.969h.651v.062H948v-556H880.829C770.261,45.989,696.012,157.621,696,284",
    className: "right-circle"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorField);
export default __webpack_public_path__ + "static/media/indoor-field.fceb4aa02f6e5bbb516b307f52c2feb6.svg";
export { ForwardRef as ReactComponent };